import { render, staticRenderFns } from "./ProjectActionsModal.vue?vue&type=template&id=79156c50&scoped=true&"
import script from "./ProjectActionsModal.vue?vue&type=script&lang=js&"
export * from "./ProjectActionsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActionsModal.vue?vue&type=style&index=0&id=79156c50&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79156c50",
  null
  
)

export default component.exports